import React, { useEffect, useState } from 'react';
import { CHECKOUT_URL } from '../data/content';

/**
 * Sticky bottom CTA. Appears once the user scrolls past the first hero CTA
 * (identified by the DOM id passed in `afterElementId`).
 */
interface FloatingCTAProps {
  afterElementId: string;
}
export function FloatingCTA({
  afterElementId
}: FloatingCTAProps) {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const target = document.getElementById(afterElementId);
    if (!target) return;
    const observer = new IntersectionObserver(entries => {
      const entry = entries[0];
      setVisible(entry.boundingClientRect.top < 0 && !entry.isIntersecting);
    }, {
      threshold: 0
    });
    observer.observe(target);
    return () => observer.disconnect();
  }, [afterElementId]);
  const handleClick = () => {
    if (typeof window !== 'undefined' && window.fbq) {
      window.fbq('track', 'InitiateCheckout');
    }
  };
  return <div className={`fixed inset-x-0 bottom-0 z-40 border-t border-white/10 bg-ink-950/95 px-3 pb-[calc(0.65rem+env(safe-area-inset-bottom))] pt-2.5 backdrop-blur transition-[opacity,transform] duration-200 ease-out ${visible ? 'translate-y-0 opacity-100' : 'pointer-events-none translate-y-full opacity-0'}`} data-id="element-27" data-mp="33i5s3uevr564">
      <div className="mx-auto flex max-w-md flex-col items-center" data-id="element-28" data-mp="2uaphpx0u902r">
        <a href={CHECKOUT_URL} onClick={handleClick} className="animate-cta-shake flex w-full items-center justify-center rounded-xl bg-teal-500 px-4 py-3.5 text-center text-sm font-extrabold uppercase tracking-wide text-ink-950 shadow-cta transition-colors duration-200 ease-out hover:bg-teal-400 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-teal-300 sm:text-base" data-id="element-29" data-mp="2u8wc8l1yolwc">
          I want the Male Fertility Route — USD 27
        </a>
        <p className="mt-1.5 text-[10px] font-medium uppercase tracking-[0.12em] text-white/45" data-id="element-30" data-mp="9ljphe0qcquf">
          Immediate download · 7-day guarantee
        </p>
      </div>
    </div>;
}